import { render } from "./card.vue?vue&type=template&id=1eea62e6&scoped=true"
const script = {}

import "./card.vue?vue&type=style&index=0&id=1eea62e6&scoped=true&lang=css"

import exportComponent from "D:\\projects\\paintcare\\pcsitelocator\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eea62e6"]])

export default __exports__